
import { defineComponent, onMounted, ref, Ref } from "vue";
import { api } from "@/services/reports/api";
import { apiExcel } from "@/services/reports/apiExcel";
import { ExpedicionesEstadoComisiones } from "@/types/reports/expediciones/expedicionesEstadoComisiones/ExpedicionesEstadoComisiones";
import { ExpedicionFilter } from "@/types/expediciones/ExpedicionView";
import loading from "@/components/loading.vue";
import footerPage from "@/components/footerPage.vue";
import excelExport from "@/components/excelExport.vue";

export default defineComponent({
  name: "Listado1",
  components: {
    loading,
    footerPage,
    excelExport
  },
  setup() {
    const report: Ref<ExpedicionesEstadoComisiones> = ref({
      totalGeneralComisionPrevista: "",
      totalGeneralComisionFacturada: "",
      totalGeneralDiferencia: "",
      totalGeneralPendientePago: "",
      fabricantes: []
    });

    const detail = ref(true);

    const isLoading = ref(true);

    async function getReport() {
      isLoading.value = true;
      const filterString = localStorage.getItem("expedicionFilter");
      let filter = {} as ExpedicionFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      //console.log('hola');
      const response = await api.getReportExpedicionEstadoComisionesDB(filter);
      report.value = response;
      //console.log(report);
      isLoading.value = false;
    }

    async function getExcel() {
      const filterString = localStorage.getItem("expedicionFilter");
      let filter = {} as ExpedicionFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      apiExcel.getReportExpedicionEstadoComisionesDB(filter);
    }

    onMounted(getReport);

    return {
      report,
      detail,
      isLoading,
      getExcel
    };
  }
});
